module.exports = __webpack_public_path__ + "img/mi-help.c87a47c7.svg";